import { Fragment, useState } from 'react';
import { NavLink } from "react-router-dom";

function Menu(props) {

    const [openChild, setOpenChild] = useState(false);

    const handleLink = (e, id, isParent) => {

        let width = getWidth();

        // If we are on mobile then do more then just redirect 
        if (width < 800) {

            if (isParent && id !== openChild) {
                // If this is a parent link then prevent the default action
                e.preventDefault();
                // let lnk = e.target.href;

                setOpenChild(id);
                // if (openChild === id) {
                //     setOpenChild(0);
                // } else {
                //     setOpenChild(id);
                // }
            } else {
                // Close the menu
                props.setMenuOpen(false);
            }
        }
    }

    const getWidth = () => {
        return Math.max(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
        );
    }


    if (props.loading || !props.menuPages) {
        return <Fragment></Fragment>;
    }

    return (
        <ul>
            {props.menuPages.map((page, i) =>
                <li key={ "item-" + i } className={ typeof page.children !== "undefined" && page.children.length > 0 ? "has-children" : "" }>
                    {page.page.template === "news" ? (
                        <NavLink className={({ isActive }) => { return isActive ? page.page.linkClass + " active" : page.page.linkClass }} to={page.page.slug}>{page.page.title.replace(" Esuubi", "")}</NavLink>
                    ) : (
                        <NavLink className={({ isActive }) => { return isActive ? page.page.linkClass + " active" : page.page.linkClass }} to={page.page.slug === "/home" ? "/" : "/p" + page.page.slug} onClick={(e) => handleLink(e, page.id, (typeof page.children !== "undefined" && page.children.length > 0) ? true : false)}>{page.page.title.replace(" Esuubi", "")}</NavLink>
                    )}
                    {typeof page.children !== "undefined" && page.children.length > 0 &&
                        <ul className={ openChild === page.id ? "mob-open" : "" }>
                            {page.children.map((child, i) =>
                                <li key={ "child-" + i }>
                                    {child.page.slug.indexOf("http") > -1 ? (
                                        <a className={ child.page.linkClass } href={child.page.slug} target="_blank" rel="noreferrer">{child.page.title.replace(" Esuubi", "")}</a>
                                    ) : (
                                        <NavLink className = { ({ isActive }) => { return isActive ? child.page.linkClass + " active" : child.page.linkClass }} to={"/p" + child.page.slug} onClick={(e) => handleLink(e, page.id, false)}>{child.page.title.replace(" Esuubi", "")}</NavLink>
                                    )}
                                </li>
                            )}
                        </ul>
                    }
                </li>
            )}
        </ul>
    );
}

export default Menu;
